import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  name: 'staging',
  production: false,
  supabaseUrl: 'https://qnkibjkggleigdryqjyc.supabase.co',
  // Supabase publishable/anon keys are public browser credentials; authorization is enforced by RLS.
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFua2liamtnZ2xlaWdkcnlxanljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAwMjg3NjEsImV4cCI6MjA3NTYwNDc2MX0.nWW_2KlWv5XqGWr4x2B-htu3xFhQPwaZPTe9oXkGd98',
  expectedProjectRef: 'qnkibjkggleigdryqjyc',
  passwordRecoveryRedirectUrl: 'https://lifeops-staging.pages.dev/reset-password'
};
